var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalSpinner",style:(_vm.styles.mainDiv || {})},[_c('div',{staticClass:"loadingSpinner",style:(_vm.styles.spinnerWrapper || {})},[_c('img',{style:(_vm.styles.spinner || {}),attrs:{"src":_vm.imageSpinner}})])])}
var staticRenderFns = []

export { render, staticRenderFns }